// Generated by generate_signing_keys.bash from signing/keys. Do not edit.

/** One public key a schema registry signature names by `keyId`: a P-256 SubjectPublicKeyInfo in PEM (SCHEMA_REGISTRY.md, "Keys"). */
export interface SigningKey {
  readonly keyId: string;
  readonly pem: string;
}

/** Every schema registry signing key, in key id order. */
export const SIGNING_KEYS: readonly SigningKey[] = [];
